module.exports = __webpack_public_path__ + "static/media/my_health.cc1ea5b8.svg";